import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminLogin.css";
import axios from "axios";
import { API_URL, showAlert, AuthContext } from "../../util/api";

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (error) {
      setError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");

    if (!form.email || !form.password) {
      setError("Please enter your email and password.");
      return;
    }

    try {
      setLoading(true);


      

       let data  = { email: form.email, password: form.password }



      const response = await axios.post(`${API_URL}/login`,   data);

      if (response.status === 200) {
        if (response.data.status === "successful") {
          showAlert('success', 'success!', response.data.message);
          login(response.data.token, response.data.data);

          

          navigate("/admin", {
            replace: true,
          });

          showAlert('success', 'success!', `Login Successful `);

          setLoading(false);

        } else {
          showAlert('Error', 'error!', response.data.message);

          setLoading(false);
        }
      } else {
        showAlert('Error', 'error!', "Server Error");

        setLoading(false);
      }





      /*
       * Login successful.
       */


    } catch (err) {
      console.error(err);

      setError(
        err.message ||
        "Unable to login. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  /*
   * Read Laravel's XSRF-TOKEN cookie.
   */
  const getXsrfToken = () => {
    const match = document.cookie.match(
      /(?:^|; )XSRF-TOKEN=([^;]*)/
    );

    return match
      ? decodeURIComponent(match[1])
      : "";
  };

  return (
    <main className="admin-login-page">

      {/* LEFT SIDE */}
      <section className="admin-login-brand">

        <div className="admin-login-brand-inner">

          <div className="admin-login-mark">
            AF
          </div>

          <p className="admin-login-label">
            ADMINISTRATION
          </p>

          {/*   <h1>
            Office of{" "}
            <em>Hon. Akindele.</em>
          </h1>
 */}
          <p className="admin-login-description">
            Secure administration portal for managing
            the official website, public information,
            news, media and constituency activities.
          </p>

          <div className="admin-login-motto">
            PEOPLE • PURPOSE • PROGRESS
          </div>

        </div>

      </section>


      {/* RIGHT SIDE */}
      <section className="admin-login-panel">

        <div className="admin-login-box">

          <div className="admin-login-header">

            <span>
              ADMIN PORTAL
            </span>

            <h2>
              Welcome back.
            </h2>

            <p>
              Sign in to continue to the
              administration dashboard.
            </p>

          </div>


          {/* ERROR */}
          {error && (
            <div
              className="admin-login-error"
              role="alert"
            >
              <span>!</span>

              <p>
                {error}
              </p>
            </div>
          )}


          <form
            className="admin-login-form"
            onSubmit={handleSubmit}
          >

            {/* EMAIL */}
            <div className="admin-form-group">

              <label htmlFor="admin-email">
                Email Address
              </label>

              <input
                id="admin-email"
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="admin@example.com"
                autoComplete="email"
                disabled={loading}
                required
              />

            </div>


            {/* PASSWORD */}
            <div className="admin-form-group">

              <div className="admin-password-label">

                <label htmlFor="admin-password">
                  Password
                </label>

                <button
                  type="button"
                  onClick={() =>
                    setShowPassword(
                      (prev) => !prev
                    )
                  }
                  tabIndex="-1"
                >
                  {showPassword
                    ? "Hide"
                    : "Show"}
                </button>

              </div>

              <input
                id="admin-password"
                type={
                  showPassword
                    ? "text"
                    : "password"
                }
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="Enter your password"
                autoComplete="current-password"
                disabled={loading}
                required
              />

            </div>


            {/* SUBMIT */}
            <button
              type="submit"
              className="admin-login-button"
              disabled={loading}
            >

              {loading ? (
                <>
                  <span className="admin-login-spinner" />
                  Signing in...
                </>
              ) : (
                <>
                  Sign In
                  <span>→</span>
                </>
              )}

            </button>

          </form>


          <div className="admin-login-footer">

            <span>
              Authorized personnel only.
            </span>

            <span>
              Secure Administration
            </span>

          </div>

        </div>

      </section>

    </main>
  );
};

export default AdminLogin;